// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 966 ? "dashboard" : chunkId) + "." + {"18":"4322ce71","52":"45725f3b","105":"2ba267ee","115":"5e19178b","123":"48be348a","156":"af5497bc","302":"b5f063e7","540":"4f224358","551":"7c2ee859","589":"420ba367","593":"811fbbe2","726":"26745205","938":"7fa59f8b","966":"4767356f","972":"1d91e314"}[chunkId] + ".js";
};